import { render } from "./PartnerReviewSingleQuiz.vue?vue&type=template&id=03f105fc&ts=true"
import script from "./PartnerReviewSingleQuiz.vue?vue&type=script&lang=ts"
export * from "./PartnerReviewSingleQuiz.vue?vue&type=script&lang=ts"

import "./PartnerReviewSingleQuiz.vue?vue&type=style&index=0&id=03f105fc&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__